import InputAdornment from '@mui/material/InputAdornment';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import React from 'react';
import AppButton from 'src/components/appComponents/AppButton';
import Iconify from 'src/components/iconify';
import { RouterLink } from 'src/routes/components';
import { handleDebouncedSearch } from 'src/utils/helper';
import AppPermissionGate from '../AppPermissionGate';

interface IAppTableToolbarProps {
  tableName: string;
  path?: string;
  permissionName?: string;
  // Table Search
  setSearch?: React.Dispatch<React.SetStateAction<any>>;
}

const AppTableToolbar: React.FC<IAppTableToolbarProps> = (props) => {
  const { tableName, path, permissionName, setSearch } = props;

  return (
    <Stack spacing={2} direction="row" alignItems="center" justifyContent="space-between">
      <TextField
        size="small"
        placeholder={`Search ${tableName}`}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Iconify icon="eva:search-fill" sx={{ color: '#c6ddb4' }} />
            </InputAdornment>
          ),
        }}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          handleDebouncedSearch(() => setSearch && setSearch(event.target.value));
        }}
      />
      {permissionName && (
        <AppPermissionGate permissionsName={[permissionName]}>
          <AppButton
            label={`Add ${tableName}`}
            buttonIcon={<Iconify icon="material-symbols:add" />}
            linkCompoennt={RouterLink}
            href={path}
          />
        </AppPermissionGate>
      )}
    </Stack>
  );
};

export default AppTableToolbar;
